/*
(i) Code is included in the final file only when a function is called, for example,
flsFunctions.spollers();
Or when the entire file is imported, for example, import "files/script.js";
Unused (uncalled) code is not included in the final file.
If we want to add a module, it should be uncommented.
*/

// Enable/disable FLS (Full Logging System) (in operation)
window['FLS_SWITCH'] = true;

// ========================================================================================================================================================================================================================================================
// Functionality ========================================================================================================================================================================================================================================================
// ========================================================================================================================================================================================================================================================
import * as flsFunctions from "./files/functions.js";

/* Checking for webp support, adding the webp or no-webp class to HTML
/ / (i) Required for proper webp display with CSS */
flsFunctions.isWebp();
/* Adding the touch class to HTML if the browser is mobile */
// flsFunctions.addTouchClass();

/* Adding the loaded class to HTML after the page is fully loaded */
// flsFunctions.addLoadedClass();

/* Module for working with the menu (Burger) */

flsFunctions.menuInit();
/* Accounting for the floating panel on mobile devices for 100vh */
// flsFunctions.fullVHfix();

/* Number formatting */
// import './libs/wNumb.min.js';

/*
Module: "Spoilers"
Documentation: https://template.fls.guru/template-docs/modul-spojlery.html
Snippet (HTML): spollers
*/

// flsFunctions.spollers();

/*
Module: "Tabs"
Documentation: https://template.fls.guru/template-docs/modul-taby.html
Snippet (HTML): tabs
*/

flsFunctions.tabs();

/*
Module: "Show More"
Documentation: https://template.fls.guru/template-docs/modul-pokazat-eshhjo.html
Snippet (HTML): showmore
*/

// flsFunctions.showMore();

/*
Module: "Ripple Effect"
Documentation: https://template.fls.guru/template-docs/modul-ripple-effect.html
Snippet (HTML):
*/
// flsFunctions.rippleEffect();

/*
Module: "Custom Cursor"
Documentation:
Snippet (HTML):
*/
// flsFunctions.customCursor(true);

/*
Module: "Popups"
Documentation: https://template.fls.guru/template-docs/funkcional-popup.html
Snippet (HTML): pl, pop
*/
// import './libs/popup.js'

/*
Mouse Parallax Module
Documentation: https://template.fls.guru/template-docs/modul-animacii-parallaks-obektov-pri-dvizhenii-myshi.html
*/
// import './libs/parallax-mouse.js'


/* Tooltip Module (Tippy) */
/*
Plugin Tippy.js setup and configuration in js/files/tippy.js
Template documentation:
Plugin documentation: https://atomiks.github.io/tippyjs/
Snippet (HTML): tip (adds tooltip attribute to HTML tag)
*/
// import "./files/tippy.js";

// ==========================================================================
// Slider Functionality (Swiper)
// ==========================================================================
/*
Slider plugin setup in js/files/sliders.js
Template documentation: https://template.fls.guru/template-docs/rabota-so-slajderom-swiper.html
Plugin documentation: https://swiperjs.com/
Snippet (HTML): swiper
*/
// import "./files/sliders.js";

// ==========================================================================
// Animation Functionality (GSAP)
// ==========================================================================
/*
GSAP animation plugin setup in js/files/gspap.js
Plugin documentation: https://greensock.com/docs/v3/GSAP
*/
// import "./files/gsap.js";

// ==========================================================================
// Scrolling Functionality
// ==========================================================================

/*
Custom Scrollbar Design
Template documentation: Add data-simplebar attribute to the HTML block
Plugin documentation: https://github.com/Grsmto/simplebar/tree/master/packages/simplebar
Snippet (HTML):
*/
// import './files/scroll/simplebar.js';

// Lazy (Deferred) Image Loading
// Template documentation: https://template.fls.guru/template-docs/modul-lenivaya-podgruzka-lazy-loading.html
// Plugin documentation: https://github.com/verlok/vanilla-lazyload
// Snippet (HTML):
import './files/scroll/lazyload.js';

// Observer for Elements with data-watch Attribute
// Documentation: https://template.fls.guru/template-docs/modul-nabljudatel-za-poyavleniem-elementa-pri-skrolle.html
// Snippet (HTML):
// import './libs/watcher.js'

// Full Page Scrolling Module
// Documentation: https://template.fls.guru/template-docs/modul-poekrannoj-prokrutki-stranicy-fullpage.html
// Snippet (HTML):
// import './libs/fullpage.js'

// Parallax Module
// Documentation: https://template.fls.guru/template-docs/paralaks-pri-skroli.html
// Snippet (HTML):
// import './libs/parallax.js'

// Scroll Functions
import * as flsScroll from "./files/scroll/scroll.js";

// Smooth Page Navigation
// Documentation: https://template.fls.guru/template-docs/modul-plavnoj-navigacii-po-stranice.html
flsScroll.pageNavigation();

// Add Classes to Header While Scrolling
// Documentation: https://template.fls.guru/template-docs/modul-dobavleniya-klassov-k-shapke-pri-prokrutke-stranicy.html
// flsScroll.headerScroll();

// Simple Fixed Header
// flsScroll.headerScrollFixed();

// Add Padding to Main for Sticky Header
// flsScroll.paddingToMain();

// Digital Counter Animation Module
// Documentation: https://template.fls.guru/template-docs/modul-animacii-cifrovogo-lichilnika.html
// Snippet (HTML):
// flsScroll.digitsCounter();

// ==========================================================================
// Gallery
// ==========================================================================
/*
Template documentation:
Plugin documentation: https://www.lightgalleryjs.com/docs/
Snippet (HTML):
*/
// import "./files/gallery.js";

// ==========================================================================
// Masonry Grid
// ==========================================================================
/*
Template documentation:
Plugin documentation:
Snippet (HTML):
*/
// import "./files/isotope.js";

// ==========================================================================
// Other Plugins
// ==========================================================================

/* Dynamic Adaptation */
// Documentation: https://template.fls.guru/template-docs/dinamicheskij-adaptiv.html
// import "./libs/dynamic_adapt.js";

// ==========================================================================
// Miscellaneous
// ==========================================================================

/* Include custom code files */

// ==========================================================================
// AOS
// ==========================================================================

AOS.init({
  duration: 1000,
  // once: true,
});


import "./files/script.js";
import "./files/scroll/class-on-scroll.js";
// import "./blocks/hero.js";
import "./blocks/we-stop-thumbs.js";
import "./blocks/what-social-is-all-about.js";
import "./blocks/social-slider.js";
import "./blocks/cards-block.js";
import "./blocks/form-block.js";
import "./blocks/together-block.js";
//============================================================================================================================================================================================================================================
